<div class="d-flex">
  <div class="col-md-12 p-0">
    <div class="detail-height">
      <div class="label-name text-style mb-1">Order ID</div>
      <div class="label-value text-style">
        {{ orderID }}
      </div>
    </div>
    <div class="detail-height">
      <div class="label-name text-style mb-1">Brand Name</div>
      <div class="label-value text-style">
        {{ brandName }}
      </div>
    </div>
    <div class="detail-height">
      <div class="label-name text-style mb-1">Product name</div>
      <div class="label-value text-style">
        {{ productName }}
      </div>
    </div>
  </div>
</div>
